export const HeaderTestID = 'ExtendTherapyReminder.HeaderTestID';
export const BodyTestID = 'ExtendTherapyReminder.BodyTestID';
export const SuccessBodyTestID = 'ExtendTherapyReminder.SuccessBodyTestID';
